// Tenant.js
import mapleLogo from "../Media/whitelogonobg.png";
import rhLogo from "../Media/new_logo.png";

export function getTenantFromUrl() {
  if (typeof window === "undefined") return "maple";

  const host = window.location.host.toLowerCase();
  const path = window.location.pathname.toLowerCase();
  const segments = path.split("/").filter(Boolean);

  // Safer path-based detection
  if (segments.includes("richmondhill") || segments.includes("rh"))
    return "richmondhill";
  if (segments.includes("maple")) return "maple";

  // Match backend hostname inference
  if (host.includes("maple")) return "maple";
  if (host.startsWith("rh") || host.includes("rh-bjj")) return "richmondhill";

  return "maple";
}

export const GYM_CONFIGS = {
  maple: {
    siteName: "Maple Jiu-Jitsu",
    addressLine: "20 Cranston Park Ave, Maple, ON, L6A 2G1",
    logoUrl: mapleLogo,
    phone: "647-887-9940",
    adminEmail: "info@maplebjj.ca",
    themeColor: "#021336",
    termsUrl: "/terms.html",
    // 🔑 backend expects this
    xMapleHeaderValue: "true",
    waiver: "https://www.smartwaiver.com/v/maple"
  },

  richmondhill: {
    siteName: "Richmond Hill BJJ",
    addressLine: "132 King Rd, Richmond Hill, ON, L4E 2T6",
    logoUrl: rhLogo,
    phone: "647-887-9940",
    adminEmail: "info@rhbjj.ca",
    themeColor: "#ffffff",
    successColor: "#0a0a0a",
    leftTheme: "light",
    termsUrl: "/terms.html",
    // 🔑 backend expects this
    xMapleHeaderValue: "false",
    waiver: "https://www.smartwaiver.com/v/rhbjj"
  },
};
